export default __webpack_public_path__ + "static/media/continuing-2.2cf9c9f5.jpg";